import { render, staticRenderFns } from "./BarEchart2.vue?vue&type=template&id=0d2df87b&"
import script from "./BarEchart2.vue?vue&type=script&lang=js&"
export * from "./BarEchart2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports